import React, {useEffect, useState} from "react";
import {ModalContentProps} from "../ModalContent";
import {Modal} from "../../../../ui/Modal/Modal";
import {Caption2} from "../../../../components/Font";
import {ContentXsTop} from "../../../../components/ui/Content";
import {useTheme} from "styled-components";
import {Moment} from "moment";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {IdentityCardTypeEnum} from "../../../../enum/identityCardTypeEnum";
import {
    cleanAllErrors,
    GetCitizenship,
    GetIdentityCardType,
    PatchIdentityCard,
    setIdentityCardType
} from "../api/slice";
import {ICitizenship} from "../../../../interface/Passport/Account/frontend";
import {Passport} from "./IdentityCardForms/Passport";
import {ForeignPassport} from "./IdentityCardForms/ForeignPassport";
import {SelectInput} from "../../../../ui/Select/SelectInput";
import {IFilter} from "../../../../interface/Basic/window";


export interface IPassportInput {
    citizenship_id: number
    identity_card_type_id: number | null
    series: string
    number: string
    issued_by: string
    department_code: string
    issued_at: Moment | null
}

export interface IForeignPassportInput {
    citizenship_id: number
    identity_card_type_id: number | null
    number: string
    issued_at: Moment | null
    expires_at: Moment | null
}

export const ChangePassport = ({onGoBack, onGoInfoModal, isInfoModalOpen}: ModalContentProps) => {

    const {passport, foreign_passport, identityCardType, citizenship, isFetching} = useAppSelector(state => state.account)
    const [selectedCountry, setSelectedCountry] = useState<ICitizenship | null>(null)
    const [countries, setCountries] = useState<ICitizenship[] | []>([])
    const [passportInfo, setPassportInfo] = useState<IPassportInput | null>(null)
    const [foreignPassportInfo, setForeignPassportInfo] = useState<IForeignPassportInput | null>(null)
    const Theme = useTheme()
    const dispatch = useAppDispatch()

    useEffect(() => {
        setCountries(citizenship)

        if (passport) {
            setForeignPassportInfo(null)
            setSelectedCountry(passport.citizenship)
            dispatch(GetIdentityCardType(passport.citizenship))
            return
        }
        if (foreign_passport) {
            setPassportInfo(null)
            setSelectedCountry(foreign_passport.citizenship)
            dispatch(GetIdentityCardType(foreign_passport.citizenship))
        }
    }, [passport, foreign_passport])

    useEffect(() => {
        dispatch(GetCitizenship())
    }, [countries])

    useEffect(() => {
        dispatch(cleanAllErrors())
        if (selectedCountry) {
            if (citizenship.find(i => i.id === selectedCountry.id)) {
                dispatch(GetIdentityCardType(selectedCountry))
            } else {
                dispatch(setIdentityCardType())

            }
        }
        if (!selectedCountry) {
            dispatch(setIdentityCardType())
        }
    }, [selectedCountry])

    const content = () => {
        return <>
            <Caption2 color={Theme.color.secondary}>
                Гражданство
            </Caption2>
            <ContentXsTop>
                <SelectInput items={citizenship}
                             onSelect={(item) => {
                                 const country = citizenship.find(i => i.id === item.id)
                                 if (country) {
                                     setSelectedCountry(country)
                                 }
                             }}
                             onInput={(item) => {
                                 setSelectedCountry(item as IFilter)
                             }}
                             selectedItem={selectedCountry ? selectedCountry : null}
                             inputValue={selectedCountry ? selectedCountry : null}
                             isCleanable={true}
                             onClean={() => {
                                 setSelectedCountry(null)
                             }}
                             placeholder={'Выберите гражданство'}

                />
            </ContentXsTop>

            {identityCardType === IdentityCardTypeEnum.Passport &&
                <Passport
                    selectedCountry={selectedCountry}
                    onChange={(info) => {
                        setPassportInfo(info)
                        if (foreignPassportInfo) {
                            setForeignPassportInfo(null)
                        }
                    }}
                />}

            {identityCardType === IdentityCardTypeEnum.ForeignPassport &&
                <ForeignPassport
                    selectedCountry={selectedCountry}
                    onChange={(info) => {
                        setForeignPassportInfo(info)
                        if (passportInfo) {
                            setPassportInfo(null)
                        }
                    }}
                />}
        </>
    }
    const isBtnDisabled = () => {
        return (!selectedCountry ||
            !identityCardType ||
            (identityCardType === IdentityCardTypeEnum.Passport
                && (!passportInfo?.series || !passportInfo.number || !passportInfo.issued_by || !passportInfo.department_code || !passportInfo.issued_at))
            || (identityCardType === IdentityCardTypeEnum.ForeignPassport
                && (!foreignPassportInfo?.number || !foreignPassportInfo.issued_at || !foreignPassportInfo.expires_at)))
    }

    return <Modal
        isFetching={isFetching}
        title={'Удостоверение личности'}
        disable={isBtnDisabled()}
        onSubmit={() => {
            if (selectedCountry) {
                if (passportInfo) {
                    dispatch(PatchIdentityCard({
                        ...passportInfo,
                        identity_card_type_id: identityCardType,
                        citizenship_id: selectedCountry.id,
                    }))
                } else if (foreignPassportInfo) {
                    dispatch(PatchIdentityCard({
                        ...foreignPassportInfo,
                        identity_card_type_id: identityCardType,
                        citizenship_id: selectedCountry.id,
                    }))
                }
            }
        }
        }
        content={content}
        onClose={() => {
            dispatch(cleanAllErrors())
            if (isInfoModalOpen) {
                onGoInfoModal()
            }
            onGoBack()
        }}
        submitText={'Сохранить'}
    />
}
